module.exports = __webpack_public_path__ + "img/RCl-Logo.ae2161b6.png";